import { DoubleChevronDown as DoubleChevronDownIcon } from '@air/icons';
import { Box } from '@air/zephyr';
import { motion } from 'framer-motion';
import { noop } from 'lodash';
import { ReactNode } from 'react';
import { UrlObject } from 'url';

import { ExternalLink, ExternalLinkProps, InternalLink, InternalLinkProps } from '~/old-marketing/components/Link';

export type LinkParam = Omit<ExternalLinkProps, 'as' | 'href'> &
  Omit<InternalLinkProps, 'as' | 'href'> & {
    href: string | (string & UrlObject);
  };

export type LinkRenderer = (link: LinkParam) => ReactNode;

export const linkRenderer: LinkRenderer = ({ analytics, children, href, id, type, tx, ...restOfProps }) => {
  const isInternalUrl = type === 'internal';
  const isLinkTo = href.charAt(0) === '#' && href.length > 1;

  if (!isInternalUrl)
    return (
      <ExternalLink
        analytics={{
          destination: href,
          destinationType: 'external',
          name: children as string,
          ...analytics,
        }}
        key={id}
        href={href}
        tx={tx}
        {...restOfProps}
      >
        {children}
      </ExternalLink>
    );

  return (
    <InternalLink
      analytics={{
        destination: href,
        destinationType: 'internal',
        ...analytics,
      }}
      key={id}
      href={href}
      onClick={
        isLinkTo
          ? (event) => {
              event.preventDefault();
              document?.getElementById(href.substr(1))?.scrollIntoView({ behavior: 'smooth' });
            }
          : noop
      }
      tx={{
        ...(isLinkTo ? { display: 'flex', alignItems: 'center', flexDirection: 'column' } : {}),
        ...tx,
      }}
      {...restOfProps}
    >
      {children}
      {isLinkTo && (
        <Box as={motion.div}>
          <Box as={DoubleChevronDownIcon} tx={{ width: 40 }} />
        </Box>
      )}
    </InternalLink>
  );
};
